export default __webpack_public_path__ + "static/media/addDisable.aaa2478c.svg";